import React from 'react';
import Link from 'gatsby-link';
import {Row, Column} from '../../global/grid/grid';
import Image from '../../global/media/Image';

import { MoreCitiesWrapper, Title } from './styled-components';

import ArrowCtaRed from '../../../static/svgs/arrow-cta-red.svg';
import ArrowCtaBlue from '../../../static/svgs/arrow-cta-blue.svg';

const MoreCities = ({data, imageDictionary}) => {
    const gaCityClicked = (city, state) => {
        window.dataLayer.push({
            'event': 'citypage-explore:click',
            'city': city + "," + state
        });
    }
    return (
        <MoreCitiesWrapper>
            <Column cw={12} style={{textAlign: 'center'}}>
                <Title>{data.title}<span className="carrot"></span></Title>
            </Column>
            {
                data.cities.map( (city, index) => {
                    return (
                        <Column key={index} className="moreCitiesItem" cw={4} offset={index === 0 ? 2 : 0} style={{position: 'relative', display: 'flex', flexDirection: 'column'}}>
                            <div className={`city ${index === 0 ? 'left' : 'right'}`}>{city.city}</div>
                            <div className={`state ${index === 0 ? 'left' : 'right'}`}>{city.state}</div>
                            <Link to={city.link} onClick={() => { gaCityClicked(city.city, city.state) }}>
                                <div className="imageHolder" style={{width: '100%', background: 'white', position: 'relative'}}>
                                    <Image aspectHeight={5} aspectWidth={4} sizes={imageDictionary[city.image].sizes} style={{opacity: '0.5'}} />
                                    <div className={`colorBlock ${index === 0 ? 'left' : 'right'}`}>
                                        <div className="stripes"></div>
                                    </div>
                                    { index === 0 &&
                                            <div className="arrowCtaHolder left">
                                                <ArrowCtaRed />
                                                <div className="ctaCopy">{data.cta}</div>
                                            </div>
                                    }
                                    { index === 1 &&
                                            <div className="arrowCtaHolder right">
                                                <ArrowCtaBlue />
                                                <div className="ctaCopy">{data.cta}</div>
                                            </div>
                                    }
                                </div>
                            </Link>
                            <div className="initialsHolder">
                                <span style={{transform: 'translate3d(0, -30px, 0) rotate(-20deg)'}}>{city.initials[0]}</span>
                                <span style={{transform: 'translate3d(0, 120px, 0) rotate(15deg)'}}>{city.initials[1]}</span>
                            </div>                        
                        </Column>
                    )
                } )
            }  
        </MoreCitiesWrapper>
    )
}

export default MoreCities;



// WEBPACK FOOTER //
// ./src/components/modules/MoreCities/MoreCities.js